import { useContext } from 'react';

import { ReferenceDataContext } from './context';

const useReferenceData = () =>
  useContext(ReferenceDataContext);

export default useReferenceData;
